<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-05 10:35:24
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-12 17:24:30
 * @FilePath: /chaoyongtuan/src/views/shopManage/addMaterial/components/good/addDrawer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-drawer
		:title="title"
		:visible.sync="visible"
		:append-to-body="appendToBody"
		:size="width"
		:before-close="handleClose"
		:wrapperClosable="wrapperClosable"
		custom-class="drawer-template"
	>
		<div>
			<div class="flex-row-align-center">
				<div class="custom flex-1 font-h6-regular yx-color-text-primary" @click="autoFocus">
					<span class="search-tag mr-12" v-if="thirdProductIds.length">
						<el-tag v-for="(tag, index) in thirdProductIds" :key="index" closable type="info" @close="closeTag(tag)" color="#F7F8FA">
							{{ tag }}
						</el-tag>
					</span>
					<input
						type="text"
						ref="input"
						v-model="textValue"
						class="search-input width100"
						placeholder="请输入商品名称/ID（商品ID支持多个搜索，按回车分隔）"
						@keydown.enter="blur"
						@blur="blur"
					/>
				</div>
				<el-button size="medium" style="width: 76px" type="primary" @click="handleSearch">搜索</el-button>
			</div>

			<el-table
				ref="table"
				class="mt-20 table-small"
				:data="tableData"
				header-row-class-name="table-header-row"
				row-class-name="table-row"
				v-loading="loading"
				element-loading-spinner="el-icon-loading"
				@selection-change="handleSelectionChange"
			>
				<el-table-column :selectable="selectable" type="selection" width="55"></el-table-column>
				<el-table-column label="商品信息">
					<template slot-scope="{ row }">
						<div class="flex-row">
							<rd-img imgType="good" :size="40" :src="row.productPic" />
							<div class="ml-8">
								<rdShopInfo :shopInfo="{ name: row.productName }" :showShopIcon="true" :platformId="row.platformId" :textWidth="260"></rdShopInfo>
								<rdText label="ID" :useByTable="false" :showCopy="false">{{ row.thirdProductId }}</rdText>
								<rdText label="店铺" :useByTable="false" :showCopy="false">{{ row.shopName }}</rdText>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="直播价" width="200px">
					<template slot-scope="{ row }">
						<div class="line-ellipsis-1">
							{{ row.livePrice | formatPrice }}
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pt-16 pb-16">
				<yx-pagination
					:total="total"
					:current-page="pageInfo.page_index"
					:page-size="pageInfo.page_size"
					@size-change="sizeChange"
					@current-change="currentChange"
				/>
			</div>
		</div>
		<div style="height: 24px" />
		<div class="drawer-footer" style="z-index: 1">
			<div class="p-12 flex-row-align-center flex-just-between width100">
				<div class="font-h4-medium">
					<span class="color-gy-9">已选</span>
					<span class="yx-color-primary ml-4 mr-4">{{ selectValue.length }}</span>
					<span class="color-gy-9">条</span>
				</div>
				<div>
					<el-button style="width: 76px" @click="handleClose">取消</el-button>
					<el-button style="width: 76px" type="primary" @click="confirm">添加</el-button>
				</div>
			</div>
		</div>
	</el-drawer>
</template>
<script>
import { debounce, uniq } from 'lodash';
import { searchProductList } from '@/api/shopManage.js';
import { isNumberAll } from '@/utils/reg';
export default {
	props: {},
	data() {
		return {
			title: '添加商品', // 弹窗标题
			visible: false, // 弹窗显隐
			loading: false, // 按钮loading状态

			textValue: '',
			thirdProductIds: [],
			tableData: [],
			selectValue: [],
			showSelectValue: [],

			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			total: 0,

			platformId: dataMap.PLATFORM_DY.value,
		};
	},
	computed: {
		// 弹窗尺寸转换为实际px值
		width() {
			return '720px';
		},
	},
	created() {
		this.initData();
	},
	mounted() {},
	methods: {
		selectable(row) {
			if (this.showSelectValue.includes(row.thirdProductId)) {
				return false;
			} else {
				return true;
			}
		},
		handleSelectionChange(val) {
			this.selectValue = val;
		},
		// 主动显示弹窗
		show(selectValue) {
			this.platformId = this.$route.query.platformId;
			this.showSelectValue = uniq(selectValue.map(item => item.thirdProductId));
			this.visible = true;
			this.getList();
		},
		// 清空数据并关闭弹窗
		handleClose() {
			this.visible = false;
			this.thirdProductIds = [];
			this.textValue = '';
		},
		// 确认按钮点击事件
		confirm: debounce(function () {
			this.selectValue.length && this.$message.success('添加成功');
			this.$emit('addData', this.selectValue, 'add');
			// 完成之后清空数据
			this.handleClose();
		}, 300),
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
		async getList() {
			this.loading = true;
			const { platformId: platform_id, thirdProductIds, pageInfo } = this;
			let query = {
				platform_id,
				third_product_id_str: thirdProductIds.join(','),
				...pageInfo,
				other_status: 1,
			};
			let params = thirdProductIds.length
				? query
				: {
						platform_id,
						...pageInfo,
						product_name: this.textValue,
						other_status: 1,
				  };
			const { list, page } = await searchProductList(params);
			this.loading = false;

			this.tableData = list;
			this.total = page.item_total;
			this.pageInfo.page_index = page.page_index;
			this.pageInfo.page_size = page.page_size;
		},
		sizeChange(value) {
			this.pageInfo.page_size = value;
			this.getList();
		},
		currentChange(value) {
			this.pageInfo.page_index = value;
			this.getList();
		},
		handleSearch() {
			this.pageInfo = {
				page_index: 1,
				page_size: 40,
			};
			this.getList();
		},
		funcNon(e) {
			let reg = isNumberAll;
			return reg.test(e);
		},
		blur() {
			if (!this.thirdProductIds.length) {
				if (this.funcNon(this.textValue)) {
					this.thirdProductIds.push(this.textValue);
					this.textValue = '';
				}
			} else {
				if (this.funcNon(this.textValue)) {
					this.thirdProductIds.push(this.textValue);
					this.textValue = '';
				} else {
					if (this.textValue) this.$message.warning('请输入商品ID');
					this.textValue = '';
				}
			}
		},
		autoFocus() {
			this.$refs.input.focus();
		},
		closeTag(tag) {
			this.thirdProductIds.splice(this.thirdProductIds.indexOf(tag), 1);
		},
	},

	beforeDestroy() {},
};
</script>

<style lang="less" scoped>
.custom {
	border: 1px solid #e0e0e0;
	padding: 4px 12px 0px 12px;
	border-right: none;
	overflow-y: hidden;
	&::-webkit-scrollbar {
		display: none;
	}
	.search-tag {
		.el-tag {
			margin-bottom: 4px;
		}
		.el-tag + .el-tag {
			margin-left: 10px;
		}
	}
	input::placeholder {
		color: #86909d;
	}
	.search-input {
		margin-bottom: 4px;
		width: 330px;
		line-height: 24px;
		height: 24px;
		font-size: 13px;
		caret-color: @color-primary;
	}
}
.drawer-footer {
	background: @color-gy1;
}
</style>
